import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "1f16b01b-3dd4-498b-96b8-17b6c304288b",
  title: "Hansons Beginner Half Marathon",
  raceType: "Half Marathon",
  units: "miles",
  workouts: [
    { description: "Rest or Cross-Train", totalDistance: 0 },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 2 miles",
      totalDistance: 2,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n3 miles @ HMP\n1.5 miles Cool Down",
      totalDistance: 6,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description: "8 miles Long Run",
      totalDistance: 8,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description:
        "1.5 miles Warm Up\n12x400m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n3 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 6,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "9 miles Long Run",
      totalDistance: 9,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description:
        "1.5 miles Warm Up\n8x600m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n3 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 6,
    },
    {
      description: "Easy 4 miles",
      totalDistance: 4,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 0,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n6x800m @ 5k-10k pace w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n4 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n5x1k @ 5k-10k pace w. 600m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n4 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1,200m @ 5k-10k pace w. 600m jog rest\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n4 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 7,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ HMP -10s w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ HMP -10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ HMP -10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n2x3 miles @ HMP -10s w. 1 miles jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n6 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "Easy 7 miles",
      totalDistance: 7,
    },
    {
      description:
        "1.5 miles Warm Up\n3x2 miles @ HMP -10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n6 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "10 miles Long Run",
      totalDistance: 10,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n4x1.5 miles @ HMP -10s w. 800m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n6 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 9,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "12 miles Long Run",
      totalDistance: 12,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "1.5 miles Warm Up\n6x1 miles @ HMP -10s w. 400m jog rest\n1.5 miles Cool Down",
      totalDistance: 10,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "1.5 miles Warm Up\n5 miles@ HMP\n1.5 miles Cool Down",
      totalDistance: 8,
    },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 8 miles",
      totalDistance: 8,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    { description: "Rest or Cross-Train", totalDistance: 0 },
    {
      description: "Easy 6 miles",
      totalDistance: 6,
    },
    {
      description: "Easy 5 miles",
      totalDistance: 5,
    },
    {
      description: "Easy 3 miles",
      totalDistance: 3,
    },
    { description: "Race Day!", totalDistance: 26.2 },
  ],
} as BuiltInPlan;